import $ from 'jquery';

import { Component } from '../core/component';

export class LoadMoreCardSet extends Component {
    constructor() {
        super();
        this.selector = '.js-load-more';
        this.page = 1;
        this.$loadMore = null;
        this.$loadMoreWrapper = null;
    }

    init() {
        this.$elements.each(() => {
            $('.js-load-more').click(function (e) {
                e.preventDefault();
                $(this).fadeOut(100);
                const nextUrl = $(this).attr('href');
                const newUrl = nextUrl;

                const $listingItems = $('.js-load-more-listing');
                const $loadMore = $(this);

                const onSuccess = function (data) {
                    const dataHtml = $(data);
                    const $newListingItems = $(dataHtml).find('.js-load-more-listing');
                    $($newListingItems.html()).appendTo($listingItems);
                    $($newListingItems).children().first().trigger('focus');
                    const $newLoadMore = $(dataHtml).find('.js-load-more');
                    if ($newLoadMore.length) {
                        $loadMore.attr('href', $newLoadMore.attr('href'));
                    } else {
                        $loadMore.closest('.js-load-more-container').remove();
                    }
                    $loadMore.fadeIn(500);
                    $(window).trigger('resize').trigger('scroll');
                };
                $.ajax({
                    url: newUrl,
                    type: 'get',
                    success: onSuccess,
                    error() {
                        // console.log('Error' + err);
                    },
                });
            });
        });
    }
}



// WEBPACK FOOTER //
// ./assets/js/components/loadMoreCardSet.js